export default __webpack_public_path__ + "87f2922dd88950fb7340280cb651c53d.png";